{
    "Absenden": "Odeslat",
    "Bitte prüfe den Link oder frag deine Gastgeber nach einem neuen.": "Zkontrolujte prosím odkaz nebo požádejte hostitele o nový.",
    "ca. {seconds} Sek.": "cca {seconds} s",
    "Danke für dein Feedback!": "Děkujeme za vaši zpětnou vazbu!",
    "Danke trotzdem, dass du dir Zeit nehmen wolltest!": "Přesto děkujeme, že jste si chtěli udělat čas!",
    "Danke, dein Feedback ist schon angekommen": "Děkujeme, vaše zpětná vazba už dorazila",
    "Dein Kommentar (optional)": "Váš komentář (nepovinné)",
    "Deine Antworten helfen deinen Gastgebern, noch besser zu werden.": "Vaše odpovědi pomáhají hostitelům být ještě lepší.",
    "Deine Antworten helfen {house}, noch besser zu werden.": "Vaše odpovědi pomáhají {house} být ještě lepší.",
    "Deine Antworten sind für den Gastgeber anonym.": "Vaše odpovědi jsou pro hostitele anonymní.",
    "Deine Antworten sind gespeichert und werden gesendet, sobald du wieder online bist.": "Vaše odpovědi jsou uložené a odešlou se, jakmile budete opět online.",
    "Deine Gastgeber haben im Moment keine Umfrage aktiviert. Schau gern später noch einmal vorbei.": "Vaši hostitelé nemají momentálně aktivní žádný dotazník. Zkuste to prosím později.",
    "Die Umfrage konnte nicht geladen werden. Prüfe deine Internetverbindung.": "Dotazník se nepodařilo načíst. Zkontrolujte připojení k internetu.",
    "Diese Umfrage ist nicht mehr verfügbar": "Tento dotazník už není k dispozici",
    "Dieser Link ist ungültig": "Tento odkaz je neplatný",
    "Erneut versuchen": "Zkusit znovu",
    "Fast oben …": "Skoro na vrcholu …",
    "Feedback geben": "Dát zpětnou vazbu",
    "Fortschritt": "Průběh",
    "Geht so": "Ujde to",
    "Gerade gibt es keine Umfrage": "Momentálně tu není žádný dotazník",
    "Gipfelstürmer": "Dobyvatel vrcholů",
    "Gut": "Dobře",
    "Ja": "Ano",
    "Ja, etwas schreiben": "Ano, něco napsat",
    "Keine Verbindung": "Žádné připojení",
    "Mehrfachauswahl möglich": "Můžete vybrat více možností",
    "Nein": "Ne",
    "Nein, fertig": "Ne, hotovo",
    "Nein, weiter": "Ne, dál",
    "Noch {count} Fragen": {
        "one": "Zbývá 1 otázka",
        "few": "Zbývají {n} otázky",
        "many": "Zbývá {n} otázek"
    },
    "Schlecht": "Špatně",
    "Sehr gut": "Velmi dobře",
    "Sehr schlecht": "Velmi špatně",
    "sehr wahrscheinlich": "velmi pravděpodobně",
    "Umfrage wird geladen …": "Načítám dotazník …",
    "unwahrscheinlich": "nepravděpodobně",
    "Zur Gäste-App": "Do aplikace pro hosty",
    "Zurück zur App": "Zpět do aplikace",
    "{value} von 5": "{value} z 5",
    "„{name}“ und alle Einträge darin werden entfernt. Das lässt sich nicht rückgängig machen.": "„{name}“ a všechny položky v něm budou odstraněny. Tuto akci nelze vrátit zpět.",
    "{count} Adressen in der Nähe": {
        "one": "1 adresa v okolí",
        "few": "{n} adresy v okolí",
        "many": "{n} adres v okolí"
    },
    "{count} Einträge liegen außerhalb des neuen Zeitraums und sind jetzt wieder ohne Tag.": {
        "one": "Jedna položka je mimo nový termín a je teď bez dne.",
        "few": "{n} položky jsou mimo nový termín a jsou teď bez dne.",
        "many": "{n} položek je mimo nový termín a je teď bez dne."
    },
    "{count} Nächte": {
        "one": "1 noc",
        "few": "{n} noci",
        "many": "{n} nocí"
    },
    "{count} Orte in der Nähe": {
        "one": "1 místo v okolí",
        "few": "{n} místa v okolí",
        "many": "{n} míst v okolí"
    },
    "{count} Tipps deiner Gastgeber": {
        "one": "1 tip vašich hostitelů",
        "few": "{n} tipy vašich hostitelů",
        "many": "{n} tipů vašich hostitelů"
    },
    "{count} Touren in der Nähe": {
        "one": "1 trasa v okolí",
        "few": "{n} trasy v okolí",
        "many": "{n} tras v okolí"
    },
    "{count}-Tage-Vorhersage": "Předpověď na {count} dní",
    "{day} · {time} Uhr": "{day} · {time}",
    "{day} · ganztägig": "{day} · celý den",
    "{day}. {mon} · {time} Uhr": "{day}. {mon} · {time}",
    "{feature} gehört zu dir, nicht zum Haus — deine Auswahl und deine Nachrichten bleiben erhalten, wenn du ein Konto anlegst. Alles andere in der App kannst du weiterhin ohne Konto nutzen.": "{feature} patří vám, ne domu — váš výběr a vaše zprávy zůstanou zachovány, jakmile si vytvoříte účet. Vše ostatní v aplikaci můžete používat i bez něj.",
    "{feature} ist bald verfügbar.": "{feature} bude brzy k dispozici.",
    "{feature} steht dir zur Verfügung, sobald deine E-Mail-Adresse bestätigt ist. Öffne dazu den Link, den wir dir geschickt haben.": "{feature} bude k dispozici, jakmile potvrdíte svou e-mailovou adresu. Otevřete odkaz, který jsme vám poslali.",
    "{from}–{to} Uhr": "{from}–{to}",
    "{label} & Gewitter": "{label} a bouřky",
    "{list} & mehr": "{list} a další",
    "{n} hm Aufstieg": "{n} m převýšení",
    "{n} km": "{n} km",
    "{n} m": "{n} m",
    "{speed} aus {compass}": "{speed} od {compass}",
    "{time} Uhr": "{time}",
    "{title} zum Planer hinzufügen": "Přidat {title} do plánovače",
    "10 – 21 Uhr": "10–21 h",
    "25 Min": "25 min",
    "50 Min": "50 min",
    "60 Min": "60 min",
    "7 Tage": "7 dní",
    "7 Tage & Details": "7 dní a detaily",
    "80 Min": "80 min",
    "Ab {age} Jahren": "Od {age} let",
    "ab {amount}": "od {amount}",
    "ab {from} Uhr": "od {from}",
    "Abbrechen": "Zrušit",
    "abgesagt": "zrušeno",
    "Abmelden": "Odhlásit se",
    "Abreise": "Odjezd",
    "AGB": "Podmínky",
    "Aktualisiert {time} Uhr": "Aktualizováno v {time}",
    "Aktuell nichts geplant": "Momentálně nic v plánu",
    "Alle": "Vše",
    "Alle ausklappen": "Rozbalit vše",
    "Alle einklappen": "Sbalit vše",
    "Alle Empfehlungen": "Všechna doporučení",
    "Alle Events": "Všechny akce",
    "Alles eingeplant. Neue Favoriten landen hier.": "Vše je naplánováno. Nové oblíbené položky se objeví zde.",
    "Alles klar": "Rozumím",
    "Alles zeigen": "Zobrazit vše",
    "Als Gast angemeldet": "Přihlášeni jako host",
    "Als Gast fortfahren": "Pokračovat jako host",
    "Als Nächstes": "Další na řadě",
    "Am Haus": "U domu",
    "Änderungen speichern": "Uložit změny",
    "Anmelden": "Přihlásit se",
    "Anmeldung erforderlich": "Nutná registrace",
    "Anmeldung fehlgeschlagen. Du kannst auch als Gast fortfahren.": "Přihlášení se nezdařilo. Můžete pokračovat i jako host.",
    "Anreise": "Příjezd",
    "Ansehen": "Zobrazit",
    "Architektur": "Architektura",
    "Auf die Tage verteilen": "Rozdělit na jednotlivé dny",
    "Aufenthalt": "Pobyt",
    "Aufguss-Zeremonie": "Saunový ceremoniál",
    "Aus dem Planer entfernt.": "Odstraněno z plánovače.",
    "Aussichtspunkt": "Vyhlídka",
    "ausverkauft": "vyprodáno",
    "Ausverkauft": "Vyprodáno",
    "Bäckerei": "Pekárna",
    "Bad & Badestelle": "Koupaliště",
    "Bar": "Bar",
    "Barrierefrei zugänglich": "Bezbariérový přístup",
    "Behandlungen": "Procedury",
    "Berghütte": "Horská chata",
    "bestätigt": "potvrzen",
    "Bewölkt": "Zataženo",
    "Bewölkung": "Oblačnost",
    "Biergarten": "Pivní zahrádka",
    "Bild {i} von {total} vergrößern": "Zvětšit obrázek {i} z {total}",
    "Bild vergrößern": "Zvětšit obrázek",
    "Bilder": "Fotografie",
    "Bitte bestätige deine E-Mail": "Potvrďte prosím svůj e-mail",
    "Bitte gib dein Passwort ein.": "Zadejte prosím své heslo.",
    "Bitte gib deinem Reiseplan einen Namen.": "Pojmenujte prosím svůj plán cesty.",
    "Bitte gib deinen Namen ein.": "Zadejte prosím své jméno.",
    "Bitte gib den Zeitraum deiner Reise an.": "Zadejte prosím termín své cesty.",
    "Bitte gib eine gültige E-Mail-Adresse ein.": "Zadejte prosím platnou e-mailovou adresu.",
    "Bitte schreib zuerst eine Nachricht.": "Nejprve prosím napište zprávu.",
    "Bitte überprüfe deine Eingaben.": "Zkontrolujte prosím zadané údaje.",
    "Bitte versuche es später erneut.": "Zkuste to prosím později.",
    "Böen": "Nárazy",
    "Bootsverleih": "Půjčovna lodí",
    "Brauerei": "Pivovar",
    "Bücherei": "Knihovna",
    "Burg & Schloss": "Hrad a zámek",
    "ca. {duration}": "cca {duration}",
    "Café": "Kavárna",
    "Chat": "Chat",
    "Check-in / Check-out": "Příjezd / odjezd",
    "Check-in und Check-out legen wir automatisch auf deinen ersten und letzten Tag.": "Příjezd a odjezd automaticky umístíme na váš první a poslední den.",
    "Check-out": "Odjezd",
    "Club": "Klub",
    "da bist.": "že jste tady.",
    "Dafür brauchst du ein Konto": "K tomu potřebujete účet",
    "Dafür fehlt dir die Berechtigung. Melde dich neu an.": "K tomu nemáte oprávnění. Přihlaste se prosím znovu.",
    "Das dauert nur einen Augenblick.": "Bude to trvat jen okamžik.",
    "Das geht nicht mehr — du hast das Maximum erreicht.": "To už nejde — dosáhli jste maxima.",
    "Das hat nicht": "To se ne",
    "Das Passwort braucht mindestens 8 Zeichen.": "Heslo musí mít alespoň 8 znaků.",
    "Das Wetter ist gerade nicht verfügbar.": "Počasí je momentálně nedostupné.",
    "Datenschutz": "Ochrana údajů",
    "Dauert unter einer Minute.": "Zabere méně než minutu.",
    "Dein Aufenthalt": "Váš pobyt",
    "Dein digitaler Begleiter für den Aufenthalt: alles zu deinem Haus und deiner Region an einem Ort.": "Váš digitální průvodce pobytem: vše o vašem domě a regionu na jednom místě.",
    "Dein Gastgeber": "Váš hostitel",
    "Dein Gastgeber hat hier noch keine Informationen hinterlegt. Schau später noch einmal vorbei — oder frag einfach direkt nach.": "Váš hostitel zde zatím nevyplnil žádné informace. Podívejte se později — nebo se rovnou zeptejte.",
    "Dein Gastgeber, {name}": "Váš hostitel, {name}",
    "Dein Planer": "Váš plánovač",
    "Deine E-Mail-Adresse ist bestätigt.": "Vaše e-mailová adresa je potvrzena.",
    "Deine Gastgeber": "Vaši hostitelé",
    "Deine Gastgeber haben hier noch nichts empfohlen.": "Vaši hostitelé zde zatím nic nedoporučili.",
    "Deine Region,": "Váš region,",
    "Deine Reisepläne konnten nicht geladen werden. Versuch es später noch einmal.": "Vaše plány cest se nepodařilo načíst. Zkuste to prosím později.",
    "deinem Gastgeber": "vašeho hostitele",
    "deiner Gastgeber": "od vašich hostitelů",
    "Denkmal": "Památník",
    "Der Chat": "Chat",
    "Der Chat konnte nicht geladen werden. Zieh nach unten oder versuch es später noch einmal.": "Chat se nepodařilo načíst. Přetáhněte dolů nebo to zkuste později.",
    "Der Eintrag konnte nicht entfernt werden.": "Položku se nepodařilo odstranit.",
    "Der Eintrag konnte nicht hinzugefügt werden.": "Položku se nepodařilo přidat.",
    "Der Eintrag konnte nicht verschoben werden.": "Položku se nepodařilo přesunout.",
    "Der Reiseplan konnte nicht erstellt werden.": "Plán cesty se nepodařilo vytvořit.",
    "Der Reiseplan konnte nicht gelöscht werden.": "Plán cesty se nepodařilo smazat.",
    "Der Reiseplan konnte nicht geöffnet werden.": "Plán cesty se nepodařilo otevřít.",
    "Der Reiseplan konnte nicht gespeichert werden.": "Plán cesty se nepodařilo uložit.",
    "Details": "Detaily",
    "Die Abreise kann nicht vor der Anreise liegen.": "Odjezd nemůže být před příjezdem.",
    "Die Empfehlungen konnten nicht geladen werden.": "Doporučení se nepodařilo načíst.",
    "Die Empfehlungen konnten nicht geladen werden. Bitte versuche es später noch einmal.": "Doporučení se nepodařilo načíst. Zkuste to prosím později.",
    "Die Karte konnte nicht geladen werden.": "Mapu se nepodařilo načíst.",
    "Die Nachricht konnte nicht gesendet werden.": "Zprávu se nepodařilo odeslat.",
    "Die Registrierung hat nicht geklappt. Bitte versuche es später erneut.": "Registrace se nezdařila. Zkuste to prosím později.",
    "Die Reihenfolge konnte nicht gespeichert werden.": "Pořadí se nepodařilo uložit.",
    "Die Veranstaltungen konnten gerade nicht geladen werden. Bitte versuche es später noch einmal.": "Akce se právě nepodařilo načíst. Zkuste to prosím později.",
    "Diese Funktion ist bald verfügbar.": "Tato funkce bude brzy k dispozici.",
    "Diese Nachricht ist zu lang.": "Tato zpráva je příliš dlouhá.",
    "Diese Unterkunft ist noch nicht freigeschaltet — Empfehlungen aus der Region erscheinen hier, sobald sie es ist.": "Toto ubytování zatím není aktivováno — doporučení z regionu se zde objeví, jakmile bude.",
    "Dieser Bereich": "Tato část",
    "Dieser Chat ist nicht mehr verfügbar.": "Tento chat už není dostupný.",
    "Dieser Eintrag ist nicht mehr verfügbar.": "Tato položka už není dostupná.",
    "Dieser Link ist unvollständig.": "Tento odkaz je neúplný.",
    "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig. Versuche dich anzumelden — dein Konto ist möglicherweise schon aktiv.": "Tento odkaz už byl použit nebo není platný. Zkuste se přihlásit — váš účet už může být aktivní.",
    "Direkt verbunden": "Přímé spojení",
    "Download": "Ke stažení",
    "Du kannst dich jetzt anmelden und deine Gästemappe nutzen.": "Nyní se můžete přihlásit a používat hostitelskou příručku.",
    "E-Mail": "E-mail",
    "E-Mail bestätigen": "Potvrďte e-mail",
    "E-Mail noch nicht bestätigt": "E-mail zatím nepotvrzen",
    "Ein Reiseplan kann höchstens 60 Tage umfassen.": "Plán cesty může zahrnovat nejvýše 60 dní.",
    "Einen Moment …": "Okamžik …",
    "Einstellungen": "Nastavení",
    "Eintritt auf Spendenbasis": "Vstupné dobrovolné",
    "Eintritt frei": "Vstup zdarma",
    "Eisdiele": "Zmrzlinárna",
    "Empfehlungen": "Doporučení",
    "Empfehlungen für deinen Zeitraum": "Doporučení pro váš termín",
    "Empfehlungen für dich": "Doporučení pro vás",
    "Endgültig löschen": "Trvale smazat",
    "Entdecken": "Objevit",
    "entdeckt.": "objevený.",
    "Entfernen": "Odebrat",
    "Erstmal ohne Konto ansehen": "Nejdřív se rozhlédnout bez účtu",
    "Events": "Akce",
    "Events & Erlebnisse": "Akce a zážitky",
    "Fast geschafft": "Skoro hotovo",
    "Favoriten sammeln": "Sbírat oblíbené",
    "Findet draußen statt": "Koná se venku",
    "Fragen zum Check-in, ein Tipp für heute Abend oder eine Bitte — {name} antwortet dir hier direkt.": "Dotazy k příjezdu, tip na dnešní večer nebo prosba — {name} vám odpoví přímo zde.",
    "frei nutzbar": "zdarma k dispozici",
    "Frühling": "Jaro",
    "Führung": "Prohlídka s průvodcem",
    "Für den Chat brauchst du ein bestätigtes Konto.": "Pro chat potřebujete potvrzený účet.",
    "Für die nächsten Stunden liegt keine Vorhersage vor.": "Pro nejbližší hodiny není k dispozici předpověď.",
    "Für die nächsten Tage sind noch keine Veranstaltungen eingetragen. Frag gern deinen Gastgeber — oft gibt es kurzfristige Tipps.": "Na nejbližší dny nejsou zapsané žádné akce. Zeptejte se hostitele — často má tipy na poslední chvíli.",
    "Für diese E-Mail-Adresse gibt es schon ein Konto. Bitte melde dich stattdessen an.": "Pro tuto e-mailovou adresu už účet existuje. Přihlaste se prosím.",
    "Für diese Kategorie gibt es hier noch keine Einträge.": "V této kategorii zatím nejsou žádné položky.",
    "Für diese Unterkunft ist der Planer nicht verfügbar.": "Pro toto ubytování není plánovač k dispozici.",
    "Für diese Unterkunft ist keine Kartenquelle hinterlegt.": "Pro toto ubytování není nastaven zdroj mapy.",
    "Für Familien geeignet": "Vhodné pro rodiny",
    "Für Hausgäste": "Pro hosty domu",
    "Galerie": "Galerie",
    "ganztägig": "celý den",
    "Gast": "Host",
    "Gästemappe": "Příručka hosta",
    "Gastgeber": "Hostitel",
    "Gastgeber fragen": "Zeptat se hostitele",
    "Gastronomie": "Gastronomie",
    "Gehört zu deinem Aufenthalt": "Patří k vašemu pobytu",
    "geklappt": "povedlo",
    "Gelesen": "Přečteno",
    "Geotop": "Geotop",
    "Geschäft": "Obchod",
    "geschlossen": "zavřeno",
    "Gesichtsbehandlung Natur": "Přírodní ošetření pleti",
    "Gestern": "Včera",
    "Gib deinem Reiseplan einen Namen und verrate uns den Zeitraum deines Aufenthalts. Danach sammelst du überall in der App Favoriten mit „Zum Planer hinzufügen“ und verteilst sie auf deine Tage.": "Pojmenujte svůj plán cesty a sdělte nám termín pobytu. Potom kdekoli v aplikaci sbírejte oblíbené položky tlačítkem „Přidat do plánovače“ a rozdělte je na jednotlivé dny.",
    "GPX-Track laden": "Stáhnout GPX trasu",
    "Gut zu wissen": "Dobré vědět",
    "Habt ihr einen Tipp für heute Abend?": "Máte tip na dnešní večer?",
    "Hallo {name},": "Dobrý den, {name},",
    "Häufige Fragen": "Časté dotazy",
    "Hauptnavigation": "Hlavní navigace",
    "Heiter": "Skoro jasno",
    "Herbst": "Podzim",
    "Herzlich willkommen —": "Srdečně vás vítáme —",
    "Heute": "Dnes",
    "Heute {hours}": "Dnes {hours}",
    "Heute geschlossen": "Dnes zavřeno",
    "Heute im Detail": "Dnes podrobně",
    "Hin und zurück": "Tam a zpět",
    "Hinzufügen": "Přidat",
    "Historische Stätte": "Historická památka",
    "Historischer Kern": "Historické jádro",
    "Hofladen": "Farmářský obchod",
    "Höhle": "Jeskyně",
    "Home": "Domů",
    "Hunde erlaubt": "Psi povoleni",
    "Ich akzeptiere die": "Souhlasím s",
    "Im Freien": "Venku",
    "Impressum": "Tiráž",
    "In der Region": "V regionu",
    "In dieser Auswahl steht gerade nichts an.": "V tomto výběru se právě nic nekoná.",
    "inkl.": "v ceně",
    "Jetzt": "Teď",
    "Kanutour": "Kanoistika",
    "Karte": "Mapa",
    "Kein Download nötig — die App lebt in deinem Browser.": "Není potřeba nic stahovat — aplikace žije ve vašem prohlížeči.",
    "Kein Konto mit dieser E-Mail-Adresse gefunden.": "Pro tuto e-mailovou adresu nebyl nalezen žádný účet.",
    "Kinderwagentauglich": "Vhodné pro kočárek",
    "Kino": "Kino",
    "Kirche": "Kostel",
    "Klar": "Jasno",
    "Klassische Rückenmassage": "Klasická masáž zad",
    "Klettertour": "Lezecká trasa",
    "Kloster": "Klášter",
    "Können wir später einchecken?": "Můžeme se ubytovat později?",
    "Konto": "Účet",
    "Konto erstellen": "Vytvořit účet",
    "Kräuterstempel-Massage": "Masáž bylinnými měšci",
    "Langlaufloipe": "Běžecká stopa",
    "Laufstrecke": "Běžecká trasa",
    "Leicht": "Lehká",
    "Leichte Schauer": "Slabé přeháňky",
    "Leichte Schneeregenschauer": "Slabé přeháňky se sněhem",
    "Leichte Schneeschauer": "Slabé sněhové přeháňky",
    "Leichter Regen": "Slabý déšť",
    "Leichter Schneefall": "Slabé sněžení",
    "Leichter Schneeregen": "Slabé sněžení s deštěm",
    "Letzter Schritt": "Poslední krok",
    "Link ungültig": "Neplatný odkaz",
    "Liste": "Seznam",
    "Los geht's": "Jdeme na to",
    "Löschen": "Smazat",
    "Luftdruck": "Tlak",
    "Luftfeuchte": "Vlhkost",
    "Mehr": "Více",
    "Mehr erfahren": "Zjistit více",
    "Mein Planer": "Můj plánovač",
    "Mein Reiseplan": "Můj plán cesty",
    "Meine Buchungen": "Moje rezervace",
    "Meine Reise · {house}": "Moje cesta · {house}",
    "Menü": "Menu",
    "Menü öffnen": "Otevřít menu",
    "Menü schließen": "Zavřít menu",
    "Merken": "Uložit",
    "Mindestens 8 Zeichen": "Alespoň 8 znaků",
    "Mittel": "Střední",
    "Morgen": "Zítra",
    "Mountainbike": "Horská kola",
    "Mühle": "Mlýn",
    "Museum": "Muzeum",
    "N": "S",
    "Nach oben": "Nahoru",
    "Nach unten": "Dolů",
    "Nachname": "Příjmení",
    "Nachricht schreiben …": "Napsat zprávu …",
    "Nächstes Bild": "Další obrázek",
    "Name deines Reiseplans": "Název vašeho plánu cesty",
    "Name und Zeitraum deiner Reise.": "Název a termín vaší cesty.",
    "Natur": "Příroda",
    "Naturinformation": "Informace o přírodě",
    "Nebel": "Mlha",
    "Neuen Link anfordern": "Vyžádat nový odkaz",
    "Neuen Reiseplan anlegen": "Vytvořit nový plán cesty",
    "Nicht mehr verfügbar": "Již není dostupné",
    "Nichts angekommen? Sieh auch im Spam-Ordner nach.": "Nic nedorazilo? Podívejte se i do složky se spamem.",
    "Nichts angekommen? Sieh im Spam-Ordner nach — die Nachricht kann einen Moment brauchen.": "Nic nedorazilo? Podívejte se do složky se spamem — zpráva může chvíli trvat.",
    "Niederschlag": "Srážky",
    "NNO": "SSV",
    "NNW": "SSZ",
    "NO": "SV",
    "Noch kein Konto?": "Ještě nemáte účet?",
    "Noch kein Reiseplan": "Zatím žádný plán cesty",
    "Notfallkontakte": "Nouzové kontakty",
    "Nur das Nötigste — in unter einer Minute fertig.": "Jen to nejnutnější — hotovo do minuty.",
    "NW": "SZ",
    "O": "V",
    "oder": "nebo",
    "Öffne den Link in der E-Mail an {email}, dann ist dein Konto startklar.": "Otevřete odkaz v e-mailu na {email} a váš účet je připraven.",
    "Öffnungszeiten": "Otevírací doba",
    "ONO": "VSV",
    "Ort wird noch bekannt gegeben": "Místo bude upřesněno",
    "OSO": "VJV",
    "Park & Garten": "Park a zahrada",
    "Parkmöglichkeit": "Parkování",
    "Passwort": "Heslo",
    "Passwort anzeigen": "Zobrazit heslo",
    "Passwort verbergen": "Skrýt heslo",
    "Passwort vergessen?": "Zapomněli jste heslo?",
    "Pilgerweg": "Poutní cesta",
    "Plane deine Reise — Tag für Tag.": "Naplánujte si cestu — den po dni.",
    "Planer": "Plánovač",
    "Radtour": "Cyklotrasa",
    "Regen": "Déšť",
    "Regenschauer": "Přeháňky",
    "Region": "Region",
    "Region-Tipps": "Tipy z regionu",
    "Regionale Vorhersage für {place}.": "Regionální předpověď pro {place}.",
    "Regionale Vorhersage.": "Regionální předpověď.",
    "Registrieren": "Registrovat se",
    "Reiseplan angelegt.": "Plán cesty byl vytvořen.",
    "Reiseplan anlegen": "Vytvořit plán cesty",
    "Reiseplan bearbeiten": "Upravit plán cesty",
    "Reiseplan erstellen": "Vytvořit plán cesty",
    "Reiseplan gelöscht.": "Plán cesty byl smazán.",
    "Reiseplan gespeichert.": "Plán cesty byl uložen.",
    "Reiseplan löschen": "Smazat plán cesty",
    "Reiseplan löschen?": "Smazat plán cesty?",
    "Reiseplan wählen": "Vybrat plán cesty",
    "Reittour": "Jezdecká trasa",
    "Rennrad": "Silniční cyklistika",
    "Reservierung erforderlich": "Nutná rezervace",
    "Restaurant": "Restaurace",
    "Restaurants": "Restaurace",
    "Restaurants, Sehenswürdigkeiten und Touren in deiner Nähe — als Liste oder auf der Karte.": "Restaurace, pamětihodnosti a trasy ve vašem okolí — v seznamu nebo na mapě.",
    "Route starten": "Spustit navigaci",
    "Ruine": "Zřícenina",
    "Rundweg": "Okruh",
    "S": "J",
    "Sächsische Schweiz": "Saské Švýcarsko",
    "Sammle alles, was dich interessiert, und ordne deine Tage so, wie es dir passt.": "Sbírejte vše, co vás zajímá, a uspořádejte si dny podle sebe.",
    "Sauna & Pool": "Sauna a bazén",
    "Schließen": "Zavřít",
    "Schneefall": "Sněžení",
    "Schneeregen": "Sněžení s deštěm",
    "Schneeregenschauer": "Přeháňky se sněhem",
    "Schneeschauer": "Sněhové přeháňky",
    "Schneeschuhtour": "Sněžnicová trasa",
    "Schnellzugriff": "Rychlý přístup",
    "schön dass du da bist.": "jsme rádi, že jste tady.",
    "Schon registriert?": "Už jste registrováni?",
    "Schön, dass du": "Jsme rádi,",
    "schön, dass du da bist.": "jsme rádi, že jste tady.",
    "Schreib deinen Gastgebern": "Napište svým hostitelům",
    "Schreib deinen Gastgebern jederzeit — oder frag den Concierge, wenn es schnell gehen soll.": "Napište svým hostitelům kdykoli — nebo se zeptejte concierge, když to má být rychle.",
    "Schreib uns – wir antworten schnell.": "Napište nám – odpovídáme rychle.",
    "Schritt {step} von {total}": "Krok {step} z {total}",
    "Schwer": "Těžká",
    "See": "Jezero",
    "Sehenswertes": "Zajímavost",
    "Sehenswürdigkeit": "Pamětihodnost",
    "Sehenswürdigkeiten": "Pamětihodnosti",
    "Sehr schwer": "Velmi těžká",
    "Senden": "Odeslat",
    "Services": "Služby",
    "SO": "JV",
    "So. 11:00 Uhr": "ne 11:00",
    "Sommer": "Léto",
    "Sonnig": "Slunečno",
    "Sonstiges": "Ostatní",
    "Spa & Wellness": "Lázně a wellness",
    "Spaziergang": "Procházka",
    "Spielplatz": "Hřiště",
    "Sport": "Sport",
    "Sprache": "Jazyk",
    "SSO": "JJV",
    "SSW": "JJZ",
    "Stadtrundgang": "Okruh městem",
    "Starke Schauer": "Silné přeháňky",
    "Starke Schneeregenschauer": "Silné přeháňky se sněhem",
    "Starke Schneeschauer": "Silné sněhové přeháňky",
    "Starker Regen": "Silný déšť",
    "Starker Schneefall": "Silné sněžení",
    "Starker Schneeregen": "Silné sněžení s deštěm",
    "Steht schon in deinem Planer.": "Už je ve vašem plánovači.",
    "Streckentour": "Trasa z místa na místo",
    "Stündlich": "Po hodinách",
    "SW": "JZ",
    "Tag {n}": "Den {n}",
    "Tagesplanung": "Plánování dnů",
    "Taupunkt": "Rosný bod",
    "Teilen": "Sdílet",
    "Teilen nicht möglich.": "Sdílení není možné.",
    "Teils bewölkt": "Polojasno",
    "Termin anfragen": "Požádat o termín",
    "Termin buchen": "Rezervovat termín",
    "Termin folgt": "Termín bude upřesněn",
    "Theater & Bühne": "Divadlo a scéna",
    "Ticket erforderlich": "Nutná vstupenka",
    "Tickets": "Vstupenky",
    "Tipps & Events aus der Region erhalten": "Dostávat tipy a akce z regionu",
    "Tour": "Trasa",
    "Touren": "Trasy",
    "Tourist-Information": "Turistické informace",
    "Überspringen": "Přeskočit",
    "UV-Index": "UV index",
    "Veranstaltung": "Akce",
    "Veranstaltungen": "Akce",
    "Veranstaltungen nicht verfügbar": "Akce nejsou dostupné",
    "Veranstaltungsort": "Místo konání",
    "Vergangene Reise. Sie bleibt ein Jahr lang für dich gespeichert.": "Uplynulá cesta. Zůstane vám uložená jeden rok.",
    "Vergrößern": "Přiblížit",
    "Verkehr": "Doprava",
    "Verkleinern": "Oddálit",
    "Verschieben": "Přesunout",
    "Verstanden": "Rozumím",
    "Vom Haus": "Od domu",
    "Vorheriges Bild": "Předchozí obrázek",
    "Vorhersage": "Předpověď",
    "Vorname": "Jméno",
    "W": "Z",
    "Wanderung": "Turistika",
    "Wann gibt es Frühstück?": "Kdy se podává snídaně?",
    "Was dich erwartet": "Co vás čeká",
    "Wasserfall": "Vodopád",
    "WC": "WC",
    "Weinabend, Sonnenaufgangstour, Konzert im Fels — alles im Haus und in der Region, mit einem Tipp gebucht.": "Vinný večer, výšlap za východem slunce, koncert ve skalách — vše v domě i v regionu, na jedno ťuknutí.",
    "Weingut": "Vinařství",
    "Weiter": "Pokračovat",
    "Weitere Termine": "Další termíny",
    "Wellness & Sauna": "Wellness a sauna",
    "Wetter": "Počasí",
    "Wetter nicht verfügbar": "Počasí není dostupné",
    "Wetter und Vorhersage": "Počasí a předpověď",
    "Wetter wird geladen …": "Načítání počasí …",
    "Wetterdaten:": "Data o počasí:",
    "Willkommen": "Vítejte",
    "Willkommen zurück": "Vítejte zpět",
    "Wind": "Vítr",
    "Winter": "Zima",
    "Winterwanderung": "Zimní turistika",
    "Wir haben dir eine Nachricht geschickt.": "Poslali jsme vám zprávu.",
    "Wir haben dir einen Bestätigungslink geschickt. Öffne ihn, damit dein Konto vollständig aktiv ist. Bis dahin kannst du die App schon nutzen.": "Poslali jsme vám potvrzovací odkaz. Otevřete jej, aby byl váš účet plně aktivní. Do té doby už můžete aplikaci používat.",
    "Wir konnten deinen Link nicht bestätigen.": "Váš odkaz se nepodařilo potvrdit.",
    "Wir melden uns mit einem Terminvorschlag.": "Ozveme se vám s návrhem termínu.",
    "Wir prüfen deinen Bestätigungslink.": "Kontrolujeme váš potvrzovací odkaz.",
    "Wird geladen …": "Načítání …",
    "WLAN, Frühstück, Check-out & mehr": "Wi-Fi, snídaně, odjezd a další",
    "WNW": "ZSZ",
    "WSW": "ZJZ",
    "z. B. Wochenende in der Sächsischen Schweiz": "např. Víkend v Saském Švýcarsku",
    "Zeitraum festlegen": "Určit termín",
    "Zieh eine Attraktion hierher.": "Přetáhněte sem nějaký tip.",
    "Zimmerservice": "Pokojová služba",
    "Zoo & Tierpark": "Zoo a zvířecí park",
    "Zu diesen Einträgen sind keine Koordinaten hinterlegt.": "U těchto položek nejsou uloženy souřadnice.",
    "Zugang verweigert. Prüfe deine Zugangsdaten.": "Přístup odepřen. Zkontrolujte své přihlašovací údaje.",
    "Zum Planer hinzufügen": "Přidat do plánovače",
    "Zur Anmeldung": "K přihlášení",
    "Zur Website": "Na web",
    "Zurück": "Zpět",
    "App zum Home-Bildschirm hinzufügen": "Přidat aplikaci na plochu",
    "Tippe auf „Teilen“ (Quadrat mit Pfeil nach oben — in Safari unten, in anderen Browsern oben) und wähle „Zum Home-Bildschirm“. Danach öffnest du die App direkt von dort — ohne Browserleiste.": "Klepněte na „Sdílet“ (čtverec se šipkou nahoru — v Safari dole, v jiných prohlížečích nahoře) a zvolte „Přidat na plochu“. Pak aplikaci otevřete přímo odtud — bez lišty prohlížeče.",
    "Installieren": "Nainstalovat",
    "Neue Version der Gäste-App verfügbar.": "Je k dispozici nová verze aplikace pro hosty.",
    "Aktualisieren": "Aktualizovat",
    "Keine Verbindung — du siehst die zuletzt geladenen Inhalte.": "Bez připojení — vidíte naposledy načtený obsah.",
    "Link kopiert.": "Odkaz zkopírován.",
    "App installieren": "Nainstalovat aplikaci",
    "Der Bildschirm kann gerade nicht angelassen werden.": "Obrazovku teď nelze nechat zapnutou.",
    "An": "Zap.",
    "Aus": "Vyp.",
    "Bildschirm anlassen, solange du der Tour folgst": "Nechat obrazovku zapnutou, dokud sledujete trasu",
    "Als App auf den Home-Bildschirm — auch offline nutzbar.": "Jako aplikace na plochu — funguje i offline.",
    "Concierge": "Concierge",
    "KI-Concierge · {house}": "AI concierge · {house}",
    "Das hat nicht geklappt. Bitte versuch es noch einmal.": "To se nepovedlo. Zkus to prosím znovu.",
    "Direkt an {name} schreiben": "Napsat přímo {name}",
    "Concierge fragen": "Zeptat se concierge",
    "Ohne Konto antwortet hier nur der Concierge. Um deinen Gastgebern direkt zu schreiben, brauchst du ein bestätigtes Konto.": "Bez účtu tu odpovídá jen concierge. Abys mohl/a psát přímo hostitelům, potřebuješ potvrzený účet.",
    "Soll ich das an {name} weitergeben?": "Mám to předat {name}?",
    "Ja, weitergeben": "Ano, předat",
    "Nein, danke": "Ne, děkuji",
    "Der Concierge schreibt …": "Concierge píše …",
    "Frag den Concierge …": "Zeptej se concierge …",
    "Der Concierge ist gerade nicht erreichbar. Mit einem bestätigten Konto kannst du deinen Gastgebern direkt schreiben.": "Concierge teď není k dispozici. S potvrzeným účtem můžeš napsat přímo hostitelům.",
    "Du schreibst jetzt direkt mit {name}. Die Antwort kommt hier.": "Teď píšeš přímo {name}. Odpověď přijde sem.",
    "Der Concierge antwortet wieder. Deine Gastgeber lesen weiter mit.": "Opět odpovídá concierge. Tví hostitelé si to dál mohou přečíst.",
    "Der Concierge ist gerade nicht verfügbar. Deine Nachricht ist bei {name} angekommen — die Antwort kommt hier.": "Concierge teď není k dispozici. Vaše zpráva dorazila k {name} — odpověď přijde sem.",
    "Dein Name wurde gespeichert.": "Jméno bylo uloženo.",
    "Dein Name konnte nicht gespeichert werden. Bitte versuche es später erneut.": "Jméno se nepodařilo uložit. Zkuste to prosím později.",
    "Bitte gib dein aktuelles Passwort ein.": "Zadejte prosím své aktuální heslo.",
    "Das neue Passwort muss sich vom aktuellen unterscheiden.": "Nové heslo se musí lišit od aktuálního.",
    "Die Passwörter stimmen nicht überein.": "Hesla se neshodují.",
    "Dein Passwort wurde geändert.": "Heslo bylo změněno.",
    "Das aktuelle Passwort stimmt nicht.": "Aktuální heslo není správné.",
    "Das Passwort konnte nicht geändert werden. Bitte versuche es später erneut.": "Heslo se nepodařilo změnit. Zkuste to prosím později.",
    "Dein Konto": "Váš účet",
    "Du nutzt die App ohne Konto": "Aplikaci používáte bez účtu",
    "Mit einem Konto kannst du deinen Namen und dein Passwort hier verwalten.": "S účtem zde můžete spravovat své jméno a heslo.",
    "Dein Name": "Vaše jméno",
    "Name": "Jméno",
    "Name speichern": "Uložit jméno",
    "Passwort ändern": "Změnit heslo",
    "Aktuelles Passwort": "Aktuální heslo",
    "Neues Passwort": "Nové heslo",
    "Mindestens {count} Zeichen.": "Alespoň {count} znaků.",
    "Neues Passwort wiederholen": "Zopakujte nové heslo",
    "Hallo,": "Dobrý den,",
    "Die App ist installiert": "Aplikace je nainstalovaná",
    "Du findest sie auf deinem Home-Bildschirm und öffnest sie von dort direkt — ohne Browserleiste.": "Najdete ji na ploše a otevřete ji přímo odtud — bez lišty prohlížeče.",
    "Zur Startseite": "Na úvodní stránku",
    "Direkt vom Home-Bildschirm starten": "Spouštění přímo z plochy",
    "Im Vollbild, ohne Browserleiste": "Na celou obrazovku, bez lišty prohlížeče",
    "Gästemappe auch ohne Internet": "Informace pro hosty i bez internetu",
    "Jetzt installieren": "Nainstalovat",
    "Dein Browser fragt noch einmal nach — bestätige dort mit „Installieren“.": "Prohlížeč se ještě jednou zeptá — potvrďte volbou „Instalovat“.",
    "So geht’s in drei Schritten": "Jak na to ve třech krocích",
    "Tippe auf „Teilen“": "Klepněte na „Sdílet“",
    "In Safari unten in der Leiste, in anderen Browsern oben rechts.": "V Safari dole na liště, v jiných prohlížečích vpravo nahoře.",
    "Wähle „Zum Home-Bildschirm“": "Zvolte „Přidat na plochu“",
    "Falls du es nicht siehst, scrolle im Menü etwas nach unten.": "Pokud ji nevidíte, posuňte se v nabídce trochu dolů.",
    "Tippe oben rechts auf „Hinzufügen“": "Klepněte vpravo nahoře na „Přidat“",
    "Fertig — die App liegt jetzt auf deinem Home-Bildschirm.": "Hotovo — aplikace je teď na vaší ploše.",
    "Dieser Browser kann die App nicht installieren. Öffne die Seite in Chrome (Android) oder Safari (iPhone und iPad) und tippe dort auf „App installieren“.": "Tento prohlížeč aplikaci nainstalovat neumí. Otevřete stránku v Chromu (Android) nebo Safari (iPhone a iPad) a klepněte tam na „Nainstalovat aplikaci“.",
    "Die App ist installiert. Du findest sie jetzt auf deinem Home-Bildschirm.": "Aplikace je nainstalovaná. Najdete ji teď na ploše.",
    "Der Link konnte nicht angefordert werden. Bitte versuche es später erneut.": "Odkaz se nepodařilo vyžádat. Zkuste to prosím později.",
    "Wir schicken dir einen Link, mit dem du ein neues Passwort vergibst.": "Pošleme vám odkaz, pomocí kterého si nastavíte nové heslo.",
    "Link anfordern": "Vyžádat odkaz",
    "Zurück zur Anmeldung": "Zpět k přihlášení",
    "Schau in dein Postfach": "Zkontrolujte svou schránku",
    "Der Link ist 2 Stunden gültig.": "Odkaz je platný 2 hodiny.",
    "Falls zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen geschickt.": "Pokud k adrese {email} existuje účet, poslali jsme vám odkaz pro obnovení hesla.",
    "Dieser Link ist abgelaufen. Bitte fordere einen neuen an.": "Platnost odkazu vypršela. Vyžádejte si prosím nový.",
    "Dieser Link wurde bereits verwendet oder ist nicht mehr gültig.": "Tento odkaz už byl použit nebo již není platný.",
    "Passwort geändert": "Heslo změněno",
    "Dein neues Passwort ist gespeichert.": "Vaše nové heslo je uloženo.",
    "Aus Sicherheitsgründen wurdest du auf allen Geräten abgemeldet. Melde dich mit deinem neuen Passwort an.": "Z bezpečnostních důvodů jste byli odhlášeni na všech zařízeních. Přihlaste se novým heslem.",
    "Neues Passwort vergeben": "Nastavit nové heslo",
    "Wähle ein neues Passwort für dein Konto.": "Zvolte nové heslo pro svůj účet.",
    "Passwort speichern": "Uložit heslo",
    "Du bist bereits angemeldet. Dein Passwort änderst du in den Einstellungen.": "Už jste přihlášeni. Heslo změníte v nastavení.",
    "Dieser Link ist abgelaufen. Fordere nach dem Anmelden einen neuen an — oder registriere dich mit derselben Adresse noch einmal.": "Platnost odkazu vypršela. Po přihlášení si vyžádejte nový — nebo se zaregistrujte znovu se stejnou adresou.",
    "Wir haben dir einen neuen Link an {email} geschickt.": "Na adresu {email} jsme vám poslali nový odkaz.",
    "Link erneut senden": "Poslat odkaz znovu",
    "Benachrichtigungen sind aktiviert.": "Oznámení jsou zapnutá.",
    "Benachrichtigungen konnten nicht geändert werden.": "Oznámení se nepodařilo změnit.",
    "Auf dem iPhone kommen Benachrichtigungen nur in der installierten App an. Füge die App zuerst zum Home-Bildschirm hinzu.": "Na iPhonu oznámení přicházejí jen do nainstalované aplikace. Nejprve si aplikaci přidejte na plochu.",
    "Benachrichtigungen sind für diese Seite blockiert. Du kannst sie in den Einstellungen deines Browsers wieder erlauben.": "Oznámení jsou pro tuto stránku zablokovaná. Znovu je můžete povolit v nastavení prohlížeče.",
    "Erhalte Hinweise zu deinem Aufenthalt, Veranstaltungen und Neuigkeiten aus dem Haus.": "Dostávejte informace k pobytu, akcím a novinkám z ubytování.",
    "Du erhältst Benachrichtigungen von diesem Haus auf diesem Gerät.": "Na tomto zařízení dostáváte oznámení od tohoto ubytování.",
    "Benachrichtigungen": "Oznámení",
    "Neuigkeiten vom Gastgeber erhalten": "Dostávat novinky od hostitele",
    "Unterkunft": "Ubytování",
    "Der Wechsel hat nicht geklappt. Bitte versuche es erneut.": "Přepnutí se nezdařilo. Zkuste to prosím znovu.",
    "Deine Anmeldung konnte nicht übernommen werden. Bitte melde dich an.": "Přihlášení se nepodařilo převzít. Přihlaste se prosím.",
    "Seite nicht gefunden": "Stránka nenalezena",
    "Diese Seite gibt es nicht": "Tato stránka neexistuje",
    "Unter dieser Adresse ist keine Gäste-App zu finden. Vielleicht hat sich ein Tippfehler eingeschlichen — oder die Unterkunft ist noch nicht freigeschaltet.": "Na této adrese není žádná aplikace pro hosty. Možná je v odkazu překlep — nebo ubytování ještě není aktivováno.",
    "Bitte prüfe den Link oder scanne den QR-Code deiner Unterkunft erneut.": "Zkontrolujte prosím odkaz nebo znovu naskenujte QR kód svého ubytování.",
    "Vorschau · Entwurf — für Gäste noch nicht sichtbar": "Náhled · Koncept — pro hosty zatím neviditelné",
    "Läuft gerade": "Právě probíhá",
    "Alle Veranstaltungen der Region.": "Všechny akce v regionu.",
    "Veranstaltungen bis {km} km Entfernung.": "Akce do vzdálenosti {km} km.",
    "Nur in der Nähe anzeigen": "Zobrazit jen v okolí",
    "Auch weiter entfernte anzeigen": "Zobrazit i vzdálenější",
    "Notruf": "Tísňové volání",
    "Feuerwehr & Rettungsdienst": "Hasiči a záchranná služba",
    "Polizei": "Policie",
    "Hat begonnen": "Už začalo",
    "Der Link ist veraltet oder unvollständig. Auf der Startseite findest du alles rund um deinen Aufenthalt.": "Odkaz je zastaralý nebo neúplný. Na úvodní stránce najdete vše o svém pobytu.",
    "Eingeplant für {day}": "Naplánováno na {day}",
    "Gemerkt — noch ohne Tag.": "Uloženo — zatím bez dne.",
    "Findet am {day} statt": "Koná se {day}",
    "Termin: {day}": "Termín: {day}",
    "Tag wählen": "Vybrat den",
    "Noch ohne Tag": "Zatím bez dne",
    "Gemerkt, noch ohne Tag": "Uloženo, zatím bez dne",
    "Wähle für jeden Eintrag einen Tag oder zieh ihn am Symbol dorthin. Die Pfeile ändern die Reihenfolge innerhalb eines Tages. Veranstaltungen mit Termin stehen schon an ihrem Tag.": "U každé položky vyberte den, nebo ji tam přetáhněte za ikonu. Šipky mění pořadí v rámci dne. Akce s pevným termínem už jsou u svého dne.",
    "Verschoben auf {day}": "Přesunuto na {day}",
    "{day} um {time} Uhr": "{day} v {time}",
    "Termin steht fest": "Termín je pevný",
    "„{title}“ findet am {when} statt. Trotzdem auf {day} legen?": "„{title}“ se koná {when}. Přesto dát na {day}?",
    "Trotzdem verschieben": "Přesto přesunout",
    "Infos zum Haus": "O domě",
    "Mein Apartment": "Můj apartmán",
    "Service & Angebote": "Služby a nabídky",
    "Rund um den Aufenthalt": "Během pobytu",
    "Anreise & Mobilität": "Příjezd a doprava",
    "Sicherheit & Notfall": "Bezpečnost a nouze",
    "Konzerte & Musik": "Koncerty a hudba",
    "Party & Nachtleben": "Párty a noční život",
    "Feste & Festivals": "Slavnosti a festivaly",
    "Märkte": "Trhy",
    "Shows & Performances": "Show a vystoupení",
    "Comedy & Kabarett": "Komedie a kabaret",
    "Film & Kino": "Film a kino",
    "Ausstellungen & Kunst": "Výstavy a umění",
    "Lesungen & Literatur": "Čtení a literatura",
    "Vorträge & Bildung": "Přednášky a vzdělávání",
    "Führungen & Touren": "Prohlídky s průvodcem",
    "Sport & Bewegung": "Sport a pohyb",
    "Kinder & Familie": "Děti a rodina",
    "Essen & Trinken": "Jídlo a pití",
    "Workshops & Kurse": "Workshopy a kurzy",
    "Brauchtum & Tradition": "Zvyky a tradice",
    "Concierge von {house}": "Concierge {house}",
    "Willkommen im {house}! Ich bin der digitale Concierge und beantworte deine Fragen rund um den Aufenthalt — jederzeit. Für alles andere leite ich dich gern an deine Gastgeber weiter.": "Vítejte v {house}! Jsem digitální concierge a odpovím na vaše otázky k pobytu — kdykoli. Se vším ostatním vás rád přepojím na vaše hostitele.",
    "KI": "AI",
    "Check-in & Ankommen": "Check-in a příjezd",
    "{address} in Google Maps öffnen": "Otevřít {address} v Google Maps"
}
